import axios from 'axios';
import loadingAnimation from '../loading-animation.vue';
import axiosError from '../axios-error.vue';
import navError from '../nav-error/nav-error.vue';
import cartOptions from '../../coto_scripts/cart/cart-slide';

export default {
  name: 'topNavigation',
  components: {
    loadingAnimation,
    axiosError,
    navError,
  },
  mixins: [],
  props: [],
  setup() {
    return {};
  },
  data() {
    return {
      error: false,
      isDropOpen: false,
      isFlagOpen: false,
      navie: [],
      gear4good: [],
    };
  },
  computed: {},
  methods: {
    navBtnToggle() {
      //if main header is open
      if ($('.menuOpen').length) {
        //alert('close menu');
        $('.dropper').removeClass('active');
        $('.level-2').removeClass('dropOpen');
        $('.drop-menu').removeClass('active');
        $('.top-nav').removeClass('menuOpen');
        $('.coto_header').removeClass('mobile-squish');
        //otherwise open it up
      } else {
        //alert('open menu');
        $('.top-nav').addClass('menuOpen');
        $('.coto_header').addClass('mobile-squish');
      }
    },
    openMenuBar(e) {
      // LEVEL 2 dropdown
      const element = e.target;
      const thisDrop = $(element).attr('data-drop');
      //console.log(thisDrop);
      if (element.classList.contains('dropper')) {
        // this has children
        //alert('has a child');
        e.preventDefault(); // stop the scroll back to the top
        if (element.classList.contains('active')) {
          //alert('closing');
          element.classList.remove('active');
          $('.level-2').removeClass('dropOpen');
          $('.drop-menu').removeClass('active');
          $('.top-nav').removeClass('menuOpen');
        } else {
          //alert('opening');
          $('.drop-menu').removeClass('active');
          $('.dropper').removeClass('active');
          element.classList.add('active');
          $('#' + thisDrop).addClass('active');
          $('.level-2').addClass('dropOpen');
          $('.top-nav').addClass('menuOpen');
        }
      }
    },
    //mobile back button
    dropBack() {
      //alert('back one level');
      $('.dropper').removeClass('active');
      $('.level-2').removeClass('dropOpen');
      $('.drop-menu').removeClass('active');
      $('.sub').removeClass('active');
    },
    //toggle level 3 menu items
    subOpen(e) {
      const thisSub = e.target.dataset.sub;
      //console.log('SUB:', e.target.dataset.sub);
      if ($('#' + thisSub).hasClass('active')) {
        // alert('isactive');
        $('#' + thisSub).removeClass('active');
      } else {
        //alert('isnt');
        $('.sub').removeClass('active');
        $('#' + thisSub).addClass('active');
      }
    },
    navSwitch() {
      if ($('.menuOpen').length) {
        // close top nav if opening G4G menu
        $('.top-nav').removeClass('menuOpen');
        $('.level-2').removeClass('dropOpen');
        $('.dropper').removeClass('active');
      }
    },

    //Core cart functions
    cartToggle() {
      let sideCartClassList = document.getElementById('sidecart').classList;
      if (sideCartClassList.contains('sidecart-open')) {
        //this.closeCart();
        e.stopPropagation();
        $('.coto_header').removeClass('cart-squish');
        cartOptions.closeCart();
      } else {
        e.stopPropagation();
        $('.dropper').removeClass('active');
        $('.level-2').removeClass('dropOpen');
        $('.drop-menu').removeClass('active');
        $('.top-nav').removeClass('menuOpen');
        $('.coto_header').addClass('cart-squish');
        cartOptions.openCart();
        //this.openCart();
      }
    },
    // get navigation links
    getLinks() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/navigation/getNavigationLinksForStorefront`
        )
        .then((response) => {
          this.navie = response.data.navTitles;
          this.gear4good = response.data.gearForGood;
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },
    //stop g4g menu from scrolling to the top on click
    stops(e) {
      if (
        $('#vue-top-navigation .navbar-custom .level-1 li a').hasClass(
          'dropper'
        )
      ) {
        e.preventDefault();
      }
    },
  },
  mounted() {
    if (!this.error) {
      const headRef = document.getElementById('top-navigation').classList;
      const gRef = document.getElementById('nav-sec').classList;
      // move navigation out of view if both menus arent open
      window.addEventListener('scroll', () => {
        var curr = window.scrollY;
        if (window.innerWidth >= 992) {
          if (!headRef.contains('menuOpen') && !gRef.contains('open')) {
            if (curr >= 900) {
              headRef.add('headerOOV');
            } else {
              headRef.remove('headerOOV');
            }
          }
        } else {
          if (!headRef.contains('menuOpen')) {
            if (curr >= 200) {
              headRef.add('headerOOV');
            } else {
              headRef.remove('headerOOV');
            }
          }
        }
      });
      this.getLinks();
    }
  },
};
